import {
  FETCH_CREATE_OWNER_REQUEST,
  FETCH_CREATE_OWNER_SUCCESS,
  FETCH_CREATE_OWNER_FALUIRE,
} from './createOwnerTypes'

const initialState = {
  loading: false,
  isCreateOwnerSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREATE_OWNER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_CREATE_OWNER_SUCCESS : return {
      ...state,
      isCreateOwnerSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_CREATE_OWNER_FALUIRE : return {
      ...state,
      loading: false,
      isCreateOwnerSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
